{
  "version": 1,
  "asset_id": "2f810f2e-e332-4c82-a67a-8d88332e7c07",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/2f810f2e-e332-4c82-a67a-8d88332e7c07/beverly-hills-shingle-replacement-in-progress-1280w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/2f810f2e-e332-4c82-a67a-8d88332e7c07/beverly-hills-shingle-replacement-in-progress-1280w.webp",
  "original_filename": "beverly-hills-shingle-replacement-in-progress-1280w.webp",
  "size": 140326,
  "content_type": "image/webp",
  "created_at": "2026-07-29T14:07:01Z"
}
